import React, { useState, useEffect } from "react";
import { Select, MenuItem as MuiMenuItem } from "@mui/material";
import toast from "react-hot-toast";
import { API } from "../../../api";
import { StyledStatusBadge } from "../../../pages/admin/products/style";

export default function PaymentStatusCell({ row, recordList }) {
  const [localPaymentStatus, setLocalPaymentStatus] = useState(row.activePaymentStatus || "");
  const [paymentUpdating, setPaymentUpdating] = useState(false);

  useEffect(() => {
    setLocalPaymentStatus(row.activePaymentStatus || "");
  }, [row.activePaymentStatus]);

  const isPaid = localPaymentStatus === "paid";

  const handlePaymentStatusChange = async (e) => {
    const newStatus = e.target.value;
    setPaymentUpdating(true);
    try {
      await API.productIntakeUpdate({
        id: row.id,
        payment_status: newStatus,
      });
      setLocalPaymentStatus(newStatus);
      toast.success("Payment status updated successfully");
      recordList?.();
    } catch (err) {
      toast.error(err?.data?.message || "Failed to update payment status");
    } finally {
      setPaymentUpdating(false);
    }
  };

  if (isPaid) {
    const dot = "#00C046";
    const label = "Paid";
    return (
      <StyledStatusBadge
        style={{
          background: "#E0F7EC",
          color: "#065F2E",
          borderColor: "#00C046",
          borderWidth: "1px",
          borderStyle: "solid",
          borderRadius: "20px",
          padding: "3px 10px",
          fontSize: "11px",
          fontWeight: 700,
          display: "inline-flex",
          alignItems: "center",
          gap: "5px",
          minWidth: 120,
          height: 28,
          boxSizing: "border-box",
        }}
      >
        <span style={{ width: 7, height: 7, borderRadius: "50%", background: dot, display: "inline-block", flexShrink: 0 }} />
        {label}
      </StyledStatusBadge>
    );
  }

  return (
    <Select
      size="small"
      value={localPaymentStatus}
      onChange={handlePaymentStatusChange}
      disabled={paymentUpdating}
      displayEmpty
      variant="outlined"
      sx={{
        fontSize: "11px",
        fontWeight: 700,
        minWidth: 120,
        height: 28,
        borderRadius: "20px",
        background: localPaymentStatus === "partial_paid" ? "#FFF3CD" : localPaymentStatus === "paid" ? "#E0F7EC" : "#FFE8EA",
        color: localPaymentStatus === "partial_paid" ? "#856404" : localPaymentStatus === "paid" ? "#065F2E" : "#9B0012",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: localPaymentStatus === "partial_paid" ? "#F0A500" : localPaymentStatus === "paid" ? "#00C046" : "#FF3850",
          borderRadius: "20px",
        },
        "& .MuiSelect-select": {
          padding: "0 28px 0 10px",
          display: "flex",
          alignItems: "center",
          gap: "5px",
        },
        "& .MuiSelect-icon": { right: 6 },
      }}
      renderValue={(val) => {
        const dot = val === "partial_paid" ? "#F0A500" : val === "paid" ? "#00C046" : "#FF3850";
        const label = val === "partial_paid" ? "Partial Paid" : val === "paid" ? "Paid" : "Unpaid";
        return (
          <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
            <span style={{ width: 7, height: 7, borderRadius: "50%", background: dot, display: "inline-block", flexShrink: 0 }} />
            {label}
          </span>
        );
      }}
    >
      <MuiMenuItem value="partial_paid" sx={{ fontSize: "12px" }}>Partial Paid</MuiMenuItem>
      <MuiMenuItem value="paid" sx={{ fontSize: "12px" }}>Paid</MuiMenuItem>
      <MuiMenuItem value="not_paid" sx={{ fontSize: "12px" }}>Unpaid</MuiMenuItem>
    </Select>
  );
}
